import { type QueryClient } from '@tanstack/react-query';

import { companyPropertiesConstants, overviewConstants } from '../../../constants/appConstants';
import { companyFeaturesQuery, companyPropertiesQuery } from '../../../queries/companyQuery';
import { getUsersByRoleId, userQuery } from '../../../queries/userQuery';

export const settingsOverviewLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const adminsQuery = getUsersByRoleId;

	const companyAdmins = await queryClient.ensureQueryData({
		queryKey: adminsQuery(overviewConstants.COMPANY_ADMIN).queryKey,
		queryFn: adminsQuery(overviewConstants.COMPANY_ADMIN).queryFn,
	});

	const teamAdmins = await queryClient.ensureQueryData({
		queryKey: adminsQuery(overviewConstants.TEAM_ADMIN).queryKey,
		queryFn: adminsQuery(overviewConstants.TEAM_ADMIN).queryFn,
	});

	const user = await queryClient.ensureQueryData(userQuery);

	const companyFeatures = await queryClient.ensureQueryData(companyFeaturesQuery);

	const companyProperties = await queryClient.ensureQueryData(
		companyPropertiesQuery(user.companyAccountId, companyPropertiesConstants),
	);

	return {
		companyAdmins,
		teamAdmins,
		companyFeatures,
		companyProperties,
		user,
	};
};
